var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightFff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(20 20) rotate(-180)",
    fill: "#5DA196"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5726 9.99612C14.5726 10.2829 14.4576 10.5696 14.2282 10.7882L7.00447 17.6679C6.54495 18.1055 5.79992 18.1055 5.34059 17.6679C4.88126 17.2304 4.88126 16.521 5.34059 16.0833L11.7325 9.99612L5.34082 3.90888C4.88148 3.47124 4.88148 2.7619 5.34082 2.32448C5.80015 1.88663 6.54518 1.88663 7.00469 2.32448L14.2284 9.20403C14.4579 9.42276 14.5726 9.70947 14.5726 9.99612Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFff);
export default __webpack_public_path__ + "static/media/arrow-rightFFF.13ca1ad85f0037a85695817e9c9c8f1c.svg";
export { ForwardRef as ReactComponent };